import { createCustomEnum } from "./customEnum";

export type NailsoftMerchantType =
	| "salon_pos"
	| "retailer"
	| "staff_one"
	| "restaurant";

const NailsoftMerchantTypes = createCustomEnum({
	SalonPOS: {
		value: 0,
		name: "salon_pos",
		displayName: "Salon POS",
	},
	Retailer: {
		value: 1,
		name: "retailer",
		displayName: "Retailer",
	},
	StaffOne: {
		value: 2,
		name: "staff_one",
		displayName: "Staff One",
	},
	Restaurant: {
		value: 2,
		name: "restaurant",
		displayName: "Restaurant",
	},
});

export default NailsoftMerchantTypes;
